export type FluentResultResponse<T = unknown> = {
  isFailed: boolean;
  isSuccess: boolean;
  reasons: FluentResultReason[];
  errors: FluentResultError[];
  successes: T[];
};

type FluentResultReason = {
  message: string;
  metadata: Record<string, unknown>;
};

type FluentResultError = {
  reasons: FluentResultReason[];
  message: string;
  metadata: Record<string, unknown>;
};

export function getFluentResultError(result: FluentResultResponse): string | null {
  if (!result?.isFailed) return null;
  return result.errors?.[0]?.message || result.reasons?.[0]?.message || 'An unexpected error occurred';
}
